import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button, Input, Icon } from 'antd';
import zmailLogo from '../../img/zmail_logo.png';
import authenticateUser from '../../authentication/authenticateUser';
import createUserProfile from '../../userFunctions/createUserProfile';
import updateUserProfile from '../../userFunctions/updateUserProfile';
import getUserProfile from '../../userFunctions/getUserProfile';
import getUserAttributes from '../../authentication/getUserAttributes';
import store from '../../reducers/store';
import loadingGif from '../../img/loading.gif';
import '../../combinedStyles';

class EmailVerification extends Component {
  constructor(props) {
    super(props);

    this.state = {
      email: this.props.email,
      verificationCode: '',
      loginStatus: '',
    };
  }

  componentWillMount() {
    getUserAttributes().then((userAttributes) => {
      this.setState({
        email: userAttributes.email,
      });
    });
  }

  handleVerificationCodeChange(event) {
    this.setState({
      verificationCode: event.target.value,
    });
  }

  handleEmailChange(event) {
    this.setState({
      email: event.target.value,
    });
  }
  updateLoginStatus(status) {
    this.setState({
      loginStatus: status,
    });
  }

  resendCode() {
    this.props.cognitoUser.getAttributeVerificationCode('email');
    document.getElementById('resendCode').disabled = true;
  }

  handleSubmitCode() {
    if (this.state.verificationCode == '') {
      this.updateLoginStatus('* Please enter code');
      return;
    }

    var cognitoUser = this.props.cognitoUser;
    var verificationCode = this.state.verificationCode;
    var that = this;
    var verificationSubmission = {
      onSuccess: (result) => {
        that.updateLoginStatus(<Icon type='loading' />);
        authenticateUser(
          localStorage.zmailUsername,
          that.props.password,
          localStorage.zmailSchoolName
        ).then(() => {
          getUserProfile()
            .then(() => {
              this.updateLoginStatus(null);
              updateUserProfile('email', this.state.email).then(() => {
                store.dispatch({ type: 'UPDATE_LOADED_CREDENTIALS', loadedCredentials: true });
                store.dispatch({ type: 'UPDATE_LOGGEDIN', loggedIn: true });
                this.props.history.push('/dashboard');
                return;
              });
            })
            .catch((err) => {
              if (err.toString().includes('No User Found')) {
                createUserProfile()
                  .then(() => {
                    this.updateLoginStatus(null);
                    store.dispatch({ type: 'UPDATE_LOADED_CREDENTIALS', loadedCredentials: true });
                    store.dispatch({ type: 'UPDATE_LOGGEDIN', loggedIn: true });
                    this.props.history.push('/dashboard');
                  })
                  .catch((err) => {
                    console.error(err);
                  });
              }
            });
        });
      },
      onFailure: (err) => {
        var errorMessage = '*' + err.toString().split(':')[1];
        console.error(errorMessage);
        that.updateLoginStatus(errorMessage);
      },
      inputVerificationCode: () => {
        return null;
      },
    };

    cognitoUser.verifyAttribute('email', verificationCode, verificationSubmission);
  }

  render() {
    return (
      <div className='loginPage'>
        <img src={zmailLogo} className='loginLogo' />
        <p style={{ color: 'black' }}>
          We have sent a verification code to{' '}
          <b>{this.state.email}. Be sure to check your spam folder.</b>
          <br />
          Please input it in the field below.
          <br />
        </p>
        <div className='loginDiv'>
          <Input
            placeholder='Verification Code'
            prefix={null}
            onChange={this.handleVerificationCodeChange.bind(this)}
            value={this.state.verificationCode}
          />
          <Button
            type='primary'
            size='large'
            className='loginButton'
            onClick={this.handleSubmitCode.bind(this)}>
            Submit Code
          </Button>
          <Button id='resendCode' className='resendCodeButton' onClick={this.resendCode.bind(this)}>
            Resend Code
          </Button>
          <br></br>
          <p className='loginStatus'>{this.state.loginStatus}</p>
        </div>
      </div>
    );
  }
}

function mapStoreToProps(storeState) {
  return {
    loggedIn: storeState.main.loggedIn,
    loadedCredentials: storeState.main.loadedCredentials,
  };
}

export default connect(mapStoreToProps)(EmailVerification);



// WEBPACK FOOTER //
// ./src/components/login/EmailVerification.js